<template lang="pug">
  //.textfield-box
  div
    b-form-input(
      :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
      @change="handleInput"
      :options="options"
      :lazy-formatter="lazyFormatter"
      :size="size"
      :value="value"
      v-b-tooltip.hover
      :title="title"
      :type="types"
      :disabled="disabled"
    )
    small.text-muted {{ title }}
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: function () { return [] }
    },
    size: {
      type: String,
      default: "sm"
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    types: {
      type: String,
      default: "number"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("input", parseInt(e));
    }
  }
};
</script>


